// extracted by mini-css-extract-plugin
export default {"section":"Xjv5qkqowElbUvWwtyOI","title":"EJvSGcS6BJvw1A5pWWOQ","scrollContainer":"F6M_k7iGzIol3k5jNwjU","scrollContent":"p9Dsw6wpriS_K9hN1lLT","cardWrapper":"XNxbEMsOmLmfyX0g8IIQ"};